import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import FileRow from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountDetails/Files/FileRow';


function TrustFile() {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <FileRow
      resource={resource}
      fileURL={resource.withRelationship(
        fr.relationships.download.name,
        (rel) => rel.link('related').url(),
        () => null,
      )}
      fileName={resource.attr('name')}
      createdAt={resource.attr('uploadedAt')}
      createdBy={resource.attr('createdBy')}
      onRemoveFile={null}
    />
  );
}

TrustFile.propTypes = {};

export default TrustFile;
